import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconInfo = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    ref={ref}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="yfm-icon yfm-icon-info"
    {...omit(props, ["className"])}
  >
    <g clipPath="url(#clip0_763_415)">
      <path
        d="M5.99975 0.000289917C2.68617 0.000289917 0 2.68646 0 6.00004C0 9.31362 2.68617 11.9998 5.99975 11.9998C9.31326 11.9998 11.9995 9.31362 11.9995 6.00004C11.9995 2.68646 9.31326 0.000289917 5.99975 0.000289917ZM7.62321 9.36732C7.27035 9.48926 6.99308 9.5833 6.78204 9.64998C6.57392 9.71658 6.32958 9.74987 6.05232 9.74987C5.62716 9.74987 5.2953 9.65545 5.06026 9.47238C4.82199 9.28383 4.7044 9.05105 4.7044 8.76253C4.7044 8.65161 4.71339 8.54062 4.73132 8.42422C4.74969 8.30783 4.77962 8.17456 4.816 8.03026L5.256 6.63795C5.2953 6.50505 5.27303 6.38311 5.30039 6.26086C5.32754 6.14447 5.33946 6.03354 5.33946 5.93942C5.33946 5.75605 5.35626 5.63411 5.27467 5.56743C5.19007 5.49536 5.03663 5.51606 4.80429 5.51606C4.6894 5.51606 4.57188 5.53256 4.45443 5.56031C4.33384 5.59368 4.23139 5.56743 4.14679 5.6008L4.26468 5.16808C4.55094 5.06263 4.8282 4.97399 5.09085 4.90183C5.35327 4.82428 5.60323 4.79099 5.83557 4.79099C6.26066 4.79099 6.58667 4.87987 6.81563 5.06293C7.04474 5.246 7.29808 5.48434 7.29808 5.77285C7.29808 5.83397 7.28871 5.93942 7.2737 6.09467C7.25877 6.24436 7.22848 6.38311 7.18619 6.51052L6.60729 7.89708C6.57392 8.00801 6.54099 8.13572 6.5137 8.28002C6.48339 8.41876 6.46847 8.52967 6.46847 8.60176C6.46847 8.78483 6.51669 8.91224 6.60729 8.97891C6.70082 9.04522 6.86063 9.07851 7.0866 9.07851C7.1922 9.07851 7.31301 9.06201 7.44845 9.02901C7.58397 8.9957 7.68049 8.96788 7.74079 8.94006L7.62321 9.36732ZM7.54498 3.74248C7.34295 3.91453 7.09597 3.99762 6.80942 3.99762C6.52307 3.99762 6.27574 3.91453 6.06755 3.74248C5.86251 3.57592 5.76007 3.37088 5.76007 3.12669C5.76007 2.88798 5.86251 2.68263 6.06755 2.5109C6.27574 2.33915 6.52309 2.2502 6.80942 2.2502C7.0956 2.2502 7.34295 2.33878 7.54498 2.5109C7.75002 2.68294 7.8527 2.88835 7.8527 3.12669C7.8527 3.37087 7.75002 3.57592 7.54498 3.74248Z"
        fill="#18B4B0"
      />
    </g>
    <defs>
      <clipPath id="clip0_763_415">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

IconInfo.displayName = "IconInfo";

export default IconInfo;
